import { Dialog } from "@mui/material"
import { useContext, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import DialogAppBar from "../../../../../components/DialogAppBar";
import { AuthContext } from "../../../../../contexts/AuthContext";
import moment from "moment";
import FormPagamentoTitulos from "./FormPagamentoTitulos";
import useSetParamsURL from "../../../../../lib/useSetParamsURL";

export default function DialogRegistrarPagamento({
    open,
    handleClose,
    valoresTitulos = []
}: DialogRegistrarPagamentoProps) {

    const { clearParamsUrl } = useSetParamsURL()
    const { userPerfilComLoja } = useContext(AuthContext);
    const lojaUsuario = userPerfilComLoja?.loja

    //Funções manipuladoras
    const handleNextStep = () => {
        const stepper = getValues('stepper')
        setValue('stepper', stepper + 1)
    }

    const handleBackStep = () => {
        const stepper = getValues('stepper')
        setValue('stepper', stepper - 1)
    }
    //

    //valores importantes
    const titPreEnviados = valoresTitulos.length > 0

    const defaultValuesForm = {
        stepper: titPreEnviados ? 1 : 0,
        preFilterStep: true,
        selecionar_titulos: valoresTitulos ? valoresTitulos : [],
        qtd_titulos: titPreEnviados ? valoresTitulos.length : 0,
        dados_pagamento: {
            forma_pagamento: 'registrar pagamento',
        },
        finalizacao: {
            aplicarDiferencaComoDesconto: false,
            usuarioComLoja: Boolean(lojaUsuario),
            data_pagamento: moment(),
            loja: lojaUsuario ? { id: lojaUsuario.id, nome: lojaUsuario.nome } : null,
            juros: '',
            pagamentos: [],
            compensacao: []
        },
        pagamentoRegistrado: null,
        funcoesAux: {
            proibidoSelectTitulos: titPreEnviados,
            onNext: handleNextStep,
            onBack: handleBackStep,
            onCloseModal: handleClose
        },
        total: 0,
        titPreEnviados: titPreEnviados
    }

    const methods = useForm({ defaultValues: defaultValuesForm })
    const { getValues, setValue } = methods
    //

    useEffect(() => {
        if (!titPreEnviados) clearParamsUrl()
    }, [])

    return (
        <FormProvider {...methods}>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                fullScreen
            >
                <DialogAppBar
                    {...{ handleClose }}
                    title="Registrar pagamento de títulos"
                />

                <FormPagamentoTitulos />
            </Dialog>
        </FormProvider>
    )
}

interface DialogRegistrarPagamentoProps {
    open: boolean;
    handleClose: () => void;
    valoresTitulos?: Array<{ id: string }>
}